/// <amd-module name="Artifacts/Root/containers/BasePage" />
import { FeedMessageBar } from "Artifacts/Root/containers/FeedMessageBar";
import { ModalManager } from "Artifacts/Root/containers/ModalManager";
import { TabTitleUpdater } from "Artifacts/Root/containers/TabTitleUpdater";
import * as React from "react";

interface IBasePageProps {
  tabTitle?: string;
}

const BasePage: React.FC<IBasePageProps> = ({ tabTitle, children }) => {
  return (
    <>
      <TabTitleUpdater tabTitle={tabTitle} />
      <FeedMessageBar />
      {children}
      <ModalManager />
    </>
  );
};

function wrapWithBasePage<T>(
  Component: React.ComponentType<T>,
  tabTitle?: string,
): React.ComponentType<T> {
  return (props: T) => {
    return (
      <BasePage tabTitle={tabTitle}>
        <Component {...props} />
      </BasePage>
    );
  };
}

export { wrapWithBasePage };
